import { useSeo } from "@/lib/useSeo";
import { IMG } from "@/lib/images";
import { PageHeader, Section, Prose, Disclaimer } from "@/components/Editorial";

const SECTIONS = [
  { t: "Qu'est-ce qu'une consultation ?", d: "Un temps d'écoute et d'échange. Une consultation ne prédit pas un avenir figé : elle propose un éclairage, une lecture, une piste de réflexion." },
  { t: "Comment se déroule une séance ?", d: "La séance s'ouvre sur votre demande. L'intuition et l'écoute guident l'échange, dans un cadre calme et respectueux." },
  { t: "Contact défunt", d: "Une démarche délicate, abordée avec beaucoup de précaution. Une photo peut être demandée si nécessaire. Rien n'est promis ni garanti." },
  { t: "Voyance", d: "Un moment de lecture intuitive autour d'une question précise, formulé avec nuance plutôt qu'avec des certitudes." },
];

const NOT = [
  "un diagnostic médical", "un avis psychologique ou thérapeutique", "un conseil juridique ou financier",
  "une promesse de résultat", "une vérité absolue et définitive",
];

export default function Mediumnite() {
  useSeo({
    title: "Médiumnité",
    description: "La médiumnité selon Dorothée Lancelot : une démarche nuancée et respectueuse, entre intuition, écoute et transmission. Consultations, contact défunt, voyance.",
    path: "/mediumnite",
    keywords: ["médiumnité", "médium", "voyance", "contact avec un défunt", "communiquer avec un défunt", "ressentir la présence d'un proche décédé", "signes d'un défunt", "consultation médiumnique"],
  });

  return (
    <div>
      <PageHeader
        eyebrow="Approche"
        title="Médiumnité"
        intro="La médiumnité n'est pas présentée ici comme un fait scientifiquement démontré, mais comme une expérience et une démarche, abordées avec respect et nuance."
        image={IMG.candle}
      />
      <Section>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {SECTIONS.map((s, i) => (
        <div key={i} className="dl-card p-8">
              <h3 className="serif text-2xl text-[#F3E9D2]">{s.t}</h3>
              <p className="text-sm text-[#F3E9D2]/70 mt-3 leading-relaxed">{s.d}</p>{(s.t === "Contactez les défunts" || s.t === "Voyance") && (
<a
href="/consultations#tarifs-charte"
className="inline-block mt-5 text-[#D4B978] underline"
>
Voir tarifs & cadre de consultation
</a>
)}
            </div>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-12">
          <Prose>
            <div className="dl-eyebrow mb-3">La place de l'intuition</div>
            <p>
              L'intuition occupe une place centrale, mais elle ne remplace ni le doute ni le discernement.
              Il existe une différence essentielle entre une croyance et une certitude — et cette distinction
              est toujours respectée.
            </p>
          </Prose>
          <div>
            <div className="dl-eyebrow mb-4">Ce qu'une consultation n'est pas</div>
            <ul className="space-y-3">
              {NOT.map((n, i) => (
                <li key={i} className="text-[#F3E9D2]/80 flex items-start gap-3"><span className="text-[#C6A76A] mt-1">—</span> {n}</li>
              ))}
            </ul>
          </div>
        </div>

        <Disclaimer>Une consultation ne remplace jamais un avis médical, psychologique, juridique ou financier.</Disclaimer>
      </Section>
    </div>
  );
}
